export default __webpack_public_path__ + "static/media/forklift.6b7a0508.png";